import { actions } from '@sloyd/store-base';
import { put } from 'saga-ts';
import { $a } from 'shared-base';

export function* runCommand(command: IEditorCommand) {
  const { id, params, isLocal, context } = command;
  let action: any;

  try {
    yield put(
      actions.editorCommands.patch(id, {
        status: 'running',
        tsStart: Date.now(),
      })
    );

    const parsedParams = parseParams(params, context) as any;

    switch (command.type) {
      case 'add-character':
        yield put($a('SCENE', 'addCharacter', id, parsedParams));
        break;
      case 'scene-instructions':
        yield put($a('SCENE', 'updateInstructions', id, parsedParams));
        break;
      case 'start-scene':
        yield put($a('SCENE', 'start', id, parsedParams));
        break;
      case 'populate-scene':
        yield put($a('SCENE', 'populate', id, parsedParams));
        break;
      case 'populate-scene':
        yield put($a('SCENE', 'populate', id, parsedParams));
        break;
      case 'populate-scene':
        yield put($a('SCENE', 'populate', id, parsedParams));
        break;
      case 'download':
        yield put($a('EDITOR', 'download', '', parsedParams));
        break;
      case 'download-image':
        yield put($a('EDITOR', 'recipe', '', parsedParams));
        break;
      case 'randomize':
        yield put($a('MODELS', 'randomize', '', parsedParams));
        break;
      case 'environment':
        yield put($a('ENVIRONMENT', 'patch', '', parsedParams));
        break;
      case 'soda':
        action = $a('PROMPT', 'editModelObject', id, parsedParams);
        action.prompt = parsedParams.prompt;
        yield put(action);
        break;
      case 'textaco':
        action = $a('PROMPT', 'editModelMaterial', id, parsedParams);
        action.prompt = parsedParams.prompt;
        yield put(action);
        break;
      case 'nog':
        action = $a('PROMPT', 'addModel', id, parsedParams);
        action.prompt = parsedParams.prompt;
        yield put(action);
        break;
      case 'switch-mode':
        yield put(actions.appState.patch({ editMode: parsedParams.editMode }));
        break;
      case 'style-transfer':
        yield put($a('TRANSFORM', 'styleTransfer', id, parsedParams));
        break;
      case 'add-model':
        yield put($a('SCENE', 'addModel', id, parsedParams));
        break;
      case 'clear-scene':
        yield put($a('SCENE', 'clear', id, parsedParams));
        break;
    }

    if (isLocal) {
      yield put(
        actions.editorCommands.patch(id, {
          status: 'success',
          tsEnd: Date.now(),
          isSuccess: true,
        })
      );
    }
  } catch (err) {}
}

const pipeFields = ['generatorId', 'backdropId', 'styleTransferStyle', 'characterId'];

export const parseParams = (params: IEditorCommandParams, context: Partial<IRealtimeState>) => {
  const output: any = {
    ...params,
    ...context,
  };

  delete output['message'];

  for (const field of pipeFields) {
    if (field in output) {
      const parts = output[field].split('|');
      output[field] = parts[0];
      output[`${field}Label`] = parts[1];
    }
  }

  return output;
};
